import React from "react";
import {Chart} from "react-google-charts";
import ReactDOM from "react-dom";
import * as WebDataRocksReact from "../../webdatarocks.react";
import ReactMarkdown from "react-markdown";

class WebDataRocksReport extends React.Component{

    myRef = null;
    currentCsvLoaded = null;
    reportData = {};
    montlyReports = [];
    anualReports = [];
    options = {
        width: 1000,
        height: 700,
        title: "Tendencias",
        hAxis: { title: "x" },
        vAxis: { title: "y" }
    };
    data = [];

    constructor(props) {
        super(props);
        this.myRef = React.createRef();
        for (const report of this.props.reportsData) {
            (report.advanced_chart.dataFrequency == "Mensual") ? this.montlyReports.push(report) : this.anualReports.push(report);
        }
    }

    componentDidMount = () => {

    }

    drawLineChart = (rawData) => {
        // const graph = rawData.data.splice(14,12);
        let graph = rawData.data;
        const months = [];
        const latestData = [];
        this.data = [];
        const _resultado = [];
        const headers = [];

        // Clean the data from unwanted fields
        for (let i = 0; i < graph.length; i++) {
            if ('r0' in graph[i] && 'c0' in graph[i] && 'v0' in graph[i]) {
                latestData.push(graph[i]);
            }
        }
        graph = latestData;

        // Get the months request and start the vertical array
        for (let i = 0; i < graph.length; i++) {
            if (months.indexOf(graph[i].c0)) {
                months.push(graph[i].c0);
                _resultado[i] = [graph[i].c0];
            } else {
                break;
            }
        }

        // Insert the data into the vertical array based on the month and the state
        let totalMonths = months.length;
        let indexMonth = 0;
        for (let i = 0; i < graph.length; i++) {
            _resultado[indexMonth].push(graph[i].v0);
            if (indexMonth < totalMonths-1) {
                indexMonth++;
            } else {
                headers.push(graph[i].r0);
                indexMonth = 0;
            }
        }

        // Fill the response to fulfill the chart format required
        headers.unshift("Mes");
        this.data.push(headers);
        for (const result of _resultado) {
            this.data.push(result);
        }
        this.createChart();
    }

    updateLineChart = (rawData) => {
        this.drawLineChart(rawData);
    }

    /*
    generateWebDataRockReport = (data) => {
        //this.loadingComponentTag();   // Used to re-render the component in case it's recreated here
        if (this.myRef.webdatarocks != null) {
            this.myRef.webdatarocks.setReport(data.webdatarockconfig);
        }
    }
    */

    generateWebDataRockReport = (data) => {
        this.loadingComponentTag();   // Used to re-render the component in case it's recreated here
        if (this.myRef.webdatarocks != null) {
            this.myRef.webdatarocks.setReport(data.advanced_chart.config);
        }
        const reportcsv = (
            <WebDataRocksReact.Pivot
                ref={(elem) => {
                    this.myRef = elem
                }}
                toolbar={true}
                beforetoolbarcreated={this.customizeToolbar}
                report={data.advanced_chart.config}
                reportcomplete={() => {
                    this.reportComplete();
                }}
            />
        );
        ReactDOM.render(reportcsv, document.getElementById('reportcsv'));
    }

    loadingComponentTag = () => {
        const loadingTag = (
            <h1>Loading CSV report</h1>
        );
        ReactDOM.render(loadingTag, document.getElementById('reportcsv'));
    }

    reportComplete = () => {
        console.log('Report completed');
        console.log(">>>>>", this.myRef.webdatarocks.getReport());
        if (this.reportData.advanced_chart.config.graph != null) {
            const chartId = this.reportData.advanced_chart.config.graph.chartId;
            if (chartId == "singleToMultiple") {
                const slice = this.formatSliceToStatesXValue(this.myRef.webdatarocks.getReport()); // Use for single to multiple
                this.myRef.webdatarocks.getData(slice, this.drawLineChart, this.updateLineChart);
            }
            if (chartId == 'multipleToSingle') {
                const slice = this.formatSliceToChart(this.myRef.webdatarocks.getReport()); // Use for single to multiple
                this.myRef.webdatarocks.getData(slice, this.multipleToSingleChart, this.updateMultipleToSingleChart);
            }
            if (chartId == 'tarifa') {
                const slice = this.formatSliceForTarifaChart(this.myRef.webdatarocks.getReport());
                this.myRef.webdatarocks.getData(this.myRef.webdatarocks.getReport(), this.chartForTarifa, this.updateTarifaChart);

            }
        }
    }

    updateTarifaChart= (rawData) => {
        this.chartForTarifa(rawData);
    }

    chartForTarifa = (rawData) =>{
        let graph = rawData.data;
        const months = [];
        const latestData = [];
        this.data = [];
        const _resultado = [];
        const headers = [];
        const resultado = [];

        // Clean the data from unwanted fields
        for (let i = 0; i < graph.length; i++) {
            if ('r0' in graph[i] && 'c0' in graph[i] && 'v0' in graph[i]) {
                latestData.push(graph[i]);
            }
        }
        graph = latestData;

        // Get the months request and start the vertical array
        for (let i = 0; i < graph.length; i++) {
            if (months.indexOf(graph[i].c0)) {
                months.push(graph[i].c0);
                _resultado[i] = [graph[i].c0];
            } else {
                break;
            }
        }

        // Insert the data into the vertical array based on the month and the state
        let totalMonths = months.length;
        let indexMonth = 0;
        for (let i = 0; i < graph.length; i++) {
            _resultado[indexMonth].push(graph[i].v0);
            if (indexMonth < totalMonths-1) {
                indexMonth++;
            } else {
                headers.push(graph[i].r0 + "");
                indexMonth = 0;
            }
        }

        // Fill the response to fulfill the chart format required
        headers.unshift("Entidad");
        this.data.push(headers);
        for (const result of _resultado) {
            this.data.push(result);
        }

        // Fill the response to fulfill the chart format required
        this.data.push(headers);
        for (const result of _resultado) {
            this.data.push(result);
        }

        this.data.splice(this.data.length / 2, this.data.length /2);
        this.createChart();
    }

    formatSliceForTarifaChart = (slice) =>  {
        if (slice.slice.rows == undefined || slice.slice.rows == null) {
            slice.slice['rows'] = [];
        }
        let rowIndex = slice.slice.rows.length;
        for (let i = 0; i < rowIndex; i++) {
            if (slice.slice.rows[i] != null) {
                if (slice.slice.rows[i].uniqueName != 'Entidad') {
                    if (slice.slice.measures == undefined || slice.slice.measures == null) {
                        slice.slice['measures'] = [];
                    }
                    slice.slice.measures.push(slice.slice.rows.splice(i, 1)[0]);
                }
            }
        }
        return slice;
    }

    multipleToSingleChart = (rawData) => {
        // const graph = rawData.data.splice(14,12);
        const graph = rawData.data;
        const vAmount = (this.reportData.advanced_chart.dataFrequency=="Mensual") ? rawData.meta.vAmount-1 : rawData.meta.vAmount; //Substract one to omit the last index array from the measure entities
        // Get the headers
        let headers = [];
        let result = [];
        headers.push(rawData.meta.c0Name);
        for (let i = 0; i < vAmount; i++) {
            headers.push(rawData.meta['v'+ i+'Name']);
        }
        result.push(headers);

        // Get the values for the chart
        for (const data of graph) {
            let row = [];
            let valueArray = []

            if (data.c0 != null && data.c0 != undefined) {
                row.push(data.c0);
                for (let i = 0; i < vAmount; i++) {
                    valueArray.push(data['v'+ i]);
                }
                result.push(row.concat(valueArray));
            }
        }
        this.data = result;
        this.createChart();
    }

    updateMultipleToSingleChart = (rawData) => {
        this.multipleToSingleChart(rawData);
    }

    formatSliceToStatesXValue = (slice) => {
        if (slice.slice.rows == undefined || slice.slice.rows == null) {
            slice.slice['rows'] = [];
        }
        let rowIndex = slice.slice.rows.length;
        for (let i = 0; i < rowIndex; i++) {
            if (slice.slice.rows[i] != null) {
                if (slice.slice.rows[i].uniqueName != 'Entidad') {
                    if (slice.slice.measures == undefined || slice.slice.measures == null) {
                        slice.slice['measures'] = [];
                    }
                    slice.slice.measures.push(slice.slice.rows.splice(i, 1)[0]);
                }
            }
        }
        return slice;
    }

    formatSliceToChart = (slice) => {
        if (slice.slice.rows == undefined || slice.slice.rows == null) {
            slice.slice['rows'] = [];
        }
        let rowIndex = slice.slice.rows.length;
        if (slice.slice.measures == undefined || slice.slice.measures == null) {
            slice.slice['measures'] = [];
        }
        for (let i = 0; i < rowIndex; i++) {
            slice.slice.measures.push(slice.slice.rows.pop());
        }
        return slice;
    }

    /*
    * Tutorial: https://www.webdatarocks.com/doc/customizing-toolbar/
    */
    customizeToolbar = (toolbar) => {
        // get all tabs
        var tabs = toolbar.getTabs();
        toolbar.getTabs = function() {

            // Delete extra tabs from the webdatarocks (connect, save, export)
            delete tabs[0];
            delete tabs[1];
            delete tabs[2];
            delete tabs[3];

            tabs.unshift({
                id: "wdr-tab-advance-options",
                title: "Mostrar Avanzado",
                icon: this.icons.format,
                handler: () => newtabHandlerBlue(toolbar)
            });

            return tabs;
        }
        var newtabHandlerBlue = (toolbar) => {
            const tab = document.getElementById('wdr-tab-advance-options').getElementsByTagName("span")[0];
            if (tab.innerText == 'Mostrar Avanzado') {
                document.getElementById('wdr-tab-format').setAttribute("style", "display: inline-block !important;");
                document.getElementById('wdr-tab-options').setAttribute("style", "display: inline-block !important;");
                document.getElementById('wdr-tab-fields').setAttribute("style", "display: inline-block !important;");
                tab.innerText = "Ocultar Avanzado";
            } else {
                document.getElementById('wdr-tab-format').setAttribute("style", "display: none !important;");
                document.getElementById('wdr-tab-options').setAttribute("style", "display: none !important;");
                document.getElementById('wdr-tab-fields').setAttribute("style", "display: none !important;");
                tab.innerText = "Mostrar Avanzado";
            }
        };
    }

    createChart = () => {
        const options = this.options;
        const graph = this.reportData.advanced_chart.config.graph;
        options.title = graph.title;
        options.hAxis.title = graph.xAxisLabel;
        options.vAxis.title = graph.yAxisLabel;
        const newChart = (
            <Chart
                width={'800px'}
                height={'400px'}
                chartType={this.reportData.advanced_chart.config.graph.chartType}
                loader={<div>Loading Chart</div>}
                data={this.data}
                options={options}
                rootProps={{ 'data-testid': '1' }}
            />
        )
        ReactDOM.render(newChart, document.getElementById('canvas'));
    }

    refreshCaption = (caption) => {
        let captionTag = (<div></div>)
        if (caption != null && caption != "") {
            captionTag = (<div className="col-lg-12 col-md-12 report-caption">
                <ReactMarkdown source={caption} />
            </div>)
        }
        ReactDOM.render(captionTag, document.getElementById('captionSection'));
    }

    /**
     * Display the webdatarock with its chart
     * @param data
     */
    displaySelectedGraph = (report, tabIdx) => {
        //this.selectedTab = report.advanced_chart.config.graph;
        this.reportData = report;
        this.refreshCaption(report.caption);
        const advanceReportButtons = document.getElementsByClassName("advanceReportButton");
        for (const advanceReportButton of advanceReportButtons) {
            advanceReportButton.classList.remove("selected");
        }
        document.getElementById(tabIdx).classList.add("selected");
        this.generateWebDataRockReport(report);
    }

    render() {

        return (
            <div>
                <div>
                    <h2>Mensual:</h2> <br/>
                    <div className="row">
                        {
                            this.montlyReports.map((report, idx) => {
                                return (
                                    <div key={idx} className="col-lg-6 col-sm-6 col-md-6">
                                            <div className={`single-industries-serve-box small advanceReportButton`} id={report.title + idx} onClick={(e) => this.displaySelectedGraph(report, report.title + idx)}>
                                                <div className="icon"><i className="flaticon-analytics"></i></div>
                                                {report.title}
                                            </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div> <br />
                <div>
                    <h2>Anual:</h2> <br/>
                    <div className="row">
                        {
                            this.anualReports.map((report, idx) => {
                                return (
                                    <div key={idx} className="col-lg-6 col-sm-6 col-md-6">
                                        <div className={`single-industries-serve-box small advanceReportButton`} id={report.title + idx} onClick={(e) => this.displaySelectedGraph(report, report.title + idx)}>
                                            <div className="icon"><i className="flaticon-analytics"></i></div>
                                            {report.title}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div> <br/>
                <div id="reportcsv"></div>
                <div id="captionSection"></div>
                <div id="canvas" style={{height: "700px"}}></div>
            </div>
        );
    }
}


export default WebDataRocksReport;
